import { Component, ContentChild, ViewEncapsulation } from '@angular/core';

/*
 * Os componentes de painel usam `ViewEncapsulation.None` de propósito: o
 * `ai-panel` estiliza, via seletores de classe, o conteúdo projetado dos
 * sub-componentes (`ai-panel-header/content/footer`). Migrar para `Emulated`
 * exigiria refatorar essa estilização entre componentes — fica para depois.
 */

/** Cabeçalho do painel. Projeta seu conteúdo dentro do {@link Panel}. */
@Component({
    selector: 'ai-panel-header',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    template: ` <ng-content></ng-content>`,
})
export class PanelHeader {}

/** Corpo do painel. */
@Component({
    selector: 'ai-panel-content',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    template: `
        <div class="ai-panel-content">
            <ng-content></ng-content>
        </div>
    `,
})
export class PanelContent {}

/**
 * Rodapé do painel.
 *
 * NOTA: o nome da classe (`PanelFotter`) tem um erro de digitação histórico;
 * renomear quebraria a API pública, então é mantido.
 */
@Component({
    selector: 'ai-panel-footer',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    template: `
        <div class="ai-panel-footer">
            <ng-content></ng-content>
        </div>
    `,
})
export class PanelFotter {}

/**
 * Painel container com cabeçalho, corpo e rodapé opcionais.
 *
 * Use junto dos sub-componentes:
 * @example
 * ```html
 * <ai-panel>
 *   <ai-panel-header><h1>Título</h1></ai-panel-header>
 *   <ai-panel-content>Conteúdo</ai-panel-content>
 *   <ai-panel-footer>Ações</ai-panel-footer>
 * </ai-panel>
 * ```
 */
@Component({
    selector: 'ai-panel',
    standalone: true,
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
})
export class Panel {
    /**
     * Cabeçalho projetado (`<ai-panel-header>`), se houver. Usado para renderizar
     * o slot do cabeçalho apenas quando existe conteúdo — painéis sem cabeçalho
     * não exibem a barra/borda vazia.
     */
    @ContentChild(PanelHeader, { static: true })
    protected readonly header?: PanelHeader;
}
